import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {Hourglass} from 'react-loader-spinner'

export default function Agen() {
    const { agenid } = useParams();
    const [allinfo, setallinfo] = useState([]);

    const [achivement, setachivement] = useState([])

    async function fetchData() {
        try {
            const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/particularagency', {
                method: 'POST',
                body: JSON.stringify({ agenid }),
                headers: { 'Content-Type': 'application/json' },
            });
            const data = await res.json();
            setallinfo(data);
        } catch (error) {
            console.error(error);
        }
    }



    async function Agencyachivement() {
        try {
            const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/agencyacheivementnumber', {
                method: 'POST',
                body: JSON.stringify({ agenid }),
                headers: { 'Content-Type': 'application/json' },
            });
            const data = await res.json();
            console.log(data);
            setachivement(data)
        } catch (error) {
            console.error(error);
        }
    }



    

    useEffect(() => {
        fetchData();
        Agencyachivement()
    }, [agenid]);

  

    const containerStyle = {
        background: 'rgba(186, 214, 237, 0.77)', // Light blue background color with 77% opacity
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Box shadow
        borderRadius: '8px', // Rounded corners
        maxWidth: '80%', // Maximum width for responsiveness
        margin: '0 auto', // Centered container
    };

    const infoStyle = {
        textAlign: 'left',
        marginTop: '10px',
    };

    return (<>

    <br />
    <br />
    <div className="bg-blue-100 p-4 rounded-lg shadow-lg m-auto w-11/12 md:w-3/4 lg:w-2/3 xl:w-1/2">
  {allinfo.length > 0 ? (
    <>
      <div className="bg-white p-3 rounded-lg shadow-lg mb-2">
        <h1 className="text-lg font-semibold">Agency Name</h1>
        <p className="text-sm">{allinfo[0].agencyName}</p>
      </div>
      <div className="bg-white p-3 rounded-lg shadow-lg mb-2">
        <h1 className="text-lg font-semibold">Email</h1>
        <p className="text-sm">{allinfo[0].email}</p>
      </div>
      <div className="bg-white p-3 rounded-lg shadow-lg mb-2">
        <h1 className="text-lg font-semibold">City</h1>
        <p className="text-sm">{allinfo[0].city}</p>
      </div>
      <div className="bg-white p-3 rounded-lg shadow-lg mb-2">
        <h1 className="text-lg font-semibold">Expertise</h1>
        <p className="text-sm">{allinfo[0].selectedOption}</p>
      </div>
      <div className="bg-white p-3 rounded-lg shadow-lg mb-2" onClick={() => { window.open(allinfo[0].websiteLink) }}>
        <h1 className="text-lg font-semibold">Website Link <span className="text-xs"> (tap to visit the Agency)</span> </h1>
        <p className="text-sm">{allinfo[0].websiteLink}</p>
      </div>
      {allinfo[0].number ? (
        <>
          <div className="bg-white p-3 rounded-lg shadow-lg">
            <h1 className="text-lg font-semibold">Contact Agency</h1>
            <p className="text-sm">{allinfo[0].number}</p>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  ) : (<>

<div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>


<Hourglass
  visible={true}
  height="80"
  width="80"
  ariaLabel="hourglass-loading"
  wrapperStyle={{}}
  wrapperClass=""
  colors={['#306cce', '#72a1ed']}
/>



</div>


    </>
  )}
</div>



<br />





{achivement.length?<>
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <strong>   <h1>ACHIEVEMENTS OF THE AGENCY</h1>  </strong>
</div>




    <div className="earthquake-info-container">
                {achivement.map((e) => (
                    <div key={e._id}             className="earthquake-info-box cursor-pointer"
                    >
                        <p className="text-lg">{e.Achievements}</p>


                        <br />


                        <div className="mt-2">
    <p className="text-gray-600">Posted on</p>
    <p className="text-blue-600">
      {new Date(e.createdAt).toLocaleString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
       
        hour12: true,
      })}
    </p>
  </div>

                



                    </div>



                    


                
                ))}
    
    </div>






</>:<>






</>}

      
        </>
    );
}
